import { ParkingType } from '@m/constants/ParkingTypes';
import { heapAddEventProperties, heapAddUserProperties, heapTrackProperties } from '@m/utils/heap';

import type { VisitType } from '@m/constants/VisitType';

/** Event properties - user & visit type */
export const trackUserType = (userType: 'new' | 'returning') => {
  heapAddEventProperties({ userType });
};

// self-park-missed-entry turns into missed entry later on
export const trackVisitType = (visitType: VisitType) => {
  heapAddEventProperties({ visitType });
};

export const trackParkingType = (parkingType: ParkingType) => {
  heapAddEventProperties({ parkingType });
};

export const trackTransactionId = (transactionId: number) => {
  heapAddEventProperties({ transactionId });
};

export const trackQRSiteId = (siteId: number) => {
  heapAddEventProperties({ siteId });
};

export const trackQRSiteName = (siteName: string) => {
  heapAddEventProperties({ siteName });
};

export const trackIsMissedEntryEnabled = (isMissedEntryEnabled: boolean) => {
  heapAddEventProperties({ isMissedEntryEnabled });
};

export const trackUserLoggedIn = (isLoggedIn: boolean) => {
  heapAddEventProperties({ isLoggedIn });
};

export const trackOnboardingFlow = (flow: 'legacy' | 'updated') => {
  heapAddEventProperties({ onboardingFlow: flow });
};

export const trackOnboardingInitialPage = (page: string) => {
  heapAddEventProperties({ onboardingInitialPage: page });
};

export const trackLoggedInAtLanding = (isLoggedIn: boolean) => {
  heapAddEventProperties({ isLoggedInAtLanding: isLoggedIn });
};

export const trackRateType = (rateType: 'durationRate' | 'flatRate' | 'tabularRate') => {
  heapAddEventProperties({ rateType });
};

/** Event properties - timestamps */
export const trackPhonePageTimestamp = () => {
  heapAddEventProperties({ phonePageTimestamp: Date.now() });
};

export const trackVerificationPageTimestamp = () => {
  heapAddEventProperties({ verificationPageTimestamp: Date.now() });
};

export const trackVehiclePageTimestamp = () => {
  heapAddEventProperties({ vehiclePageTimestamp: Date.now() });
};

export const trackPaymentPageTimestamp = () => {
  heapAddEventProperties({ paymentPageTimestamp: Date.now() });
};

export const trackPaymentAddedTimestamp = () => {
  heapAddEventProperties({ paymentAddedTimestamp: Date.now() });
};

export const trackEmailPageTimestamp = () => {
  heapAddEventProperties({ emailPageTimestamp: Date.now() });
};

export const trackEmailAddedTimestamp = () => {
  heapAddEventProperties({ emailAddedTimestamp: Date.now() });
};

export const trackEmailSkipped = () => {
  heapTrackProperties('EmailSkipped', { skippedAt: Date.now() });
};

export const trackLandingPageTimestamp = () => {
  heapAddEventProperties({ landingPageTimestamp: Date.now() });
};

export const trackVisitStartTimestamp = () => {
  heapAddEventProperties({ visitStartTimestamp: Date.now() });
};
export const trackIsFirstTimeUser = (isFirstTimeUser: boolean) => {
  heapAddEventProperties({ isFirstTimeUser });
};

export const trackDoesHaveSubcriptions = (data: {
  isCompanySubscriber: boolean;
  isMonthlySubscriber: boolean;
}) => {
  heapAddUserProperties(data);
};
/**
 * Custom tracking
 * errorMessage may contain license plate text
 */
export const trackFailedAddVehicle = (failureData: { [x: string]: string }) => {
  heapTrackProperties('addVehicleFailed', failureData);
};

export const trackVisitId = (visitId: number) => {
  heapTrackProperties('Visit Info', {
    visitId,
  });
};

export const trackCieFlowStarted = (data: { isFallback: boolean; userFlow: string }) => {
  const send = { ...data, isFallback: data.isFallback ? 'true' : 'false' };
  heapTrackProperties('CieFlowStarted', send);
};

export const trackCieFlowCompleted = (data: {
  isFallback: boolean;
  transactionId: number | undefined;
  userFlow: string;
}) => {
  const send = { ...data, isFallback: data.isFallback ? 'true' : 'false' };
  heapTrackProperties('CieFlowCompleted', send);
};

export const trackLpCorrectionFlow = (lpCorrectionData: { [x: string]: string }) => {
  heapTrackProperties('LPCorrectionTransaction', lpCorrectionData);
};

export const trackPastDueVisitViewed = (numItems: number) => {
  heapTrackProperties('PastDueVisitViewed', { numItems });
};

export const trackPastDueVisitPaid = (numItems: number) => {
  heapTrackProperties('PastDueVisitPaid', { numItems });
};

export const trackDontKnowPlateOpen = () => {
  heapTrackProperties('DontKnowLicensePlate:Open', { timestamp: Date.now() });
};

export const trackDontKnowPlateClose = () => {
  heapTrackProperties('DontKnowLicensePlate:Close', { timestamp: Date.now() });
};

export const trackDontKnowPlateLinkViewed = (siteId: number) => {
  heapTrackProperties('DontKnowLicensePlate:LinkViewed', { siteId });
};

export const trackDontKnowPlateLinkClicked = (siteId: number) => {
  heapTrackProperties('DontKnowLicensePlate:LinkClicked', { siteId });
};
